module.exports = __webpack_public_path__ + "img/blog_2.120d9c1e.png";